import * as React from 'react';
import {Image} from "react-bootstrap";

export function Footer() {
    return (
        <footer className="footer-container d-flex flex-row justify-content-center align-items-center gap-5 pt-3">
            <div>
                <p>EccoPresso Kft.</p>
                <p>+36 204824335</p>
                <p>1154 Budapest, Damjanich János utca 2.</p>
                <p>www.eccopresso.com</p>
                <p>info@eccopresso.com</p>
            </div>
            <Image
                className="footer-logo my-2"
                src="/assets/EccoPresso_logo_pod_start.svg"
            />
        </footer>
    );
};